// extracted by mini-css-extract-plugin
export default {"errorMessagePointer":"NumberField-module__errorMessagePointer--OzQjU","numberInput":"NumberField-module__numberInput--niEAY"};